<template>
  <el-button native-type="button" @click="generateBarcode">
    <Icon v-if="!loading" icon="fluent:barcode-scanner-add-16-filled" class="text-lg"/>
    <Icon v-else icon="line-md:loading-loop" class="text-lg"/>
  </el-button>
</template>
<script lang="ts" setup>

import {useHTTP} from "@/plugins/http";
import {ref} from "vue";
import {Icon} from "@iconify/vue";

const emit = defineEmits(['onBarcode'])
const http = useHTTP();
const loading = ref(false)

async function generateBarcode() {
  try {
    loading.value = true;
    const resp = await http.post<string>("/helpers/barcode");
    emit('onBarcode', resp)
  } catch (e) {
    loading.value = false;
    console.log(e)
  } finally {
    loading.value = false;
  }
}
</script>
